// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavbarHospital_menu__Z4RL0"};